import { z } from "zod";
import { MetaSchema } from "./shared";
import { TransferPaymentFineEnum } from "../enums";
import { LoanSchema } from "./shared/LoanSchema";
import { LoanTransactionSchema as BaseLoanTransactionSchema } from "./shared/LoanTransactionSchema";

export const TransactionSchema = z.object({
  id: z.string().uuid(),
  transaction_type: z.string(),
  coin: z.string(),
  type: z.string(),
  value: z.string(),
  amount: z.string(),
  fee: z.string(),
  tracerKey: z.string().nullable(),
  useGGold: z.boolean().nullable(),
  useProfit: z.boolean().nullable(),
  hash: z.string(),
  created_at: z.string().datetime(),
  completedAt: z.string().nullable(),
  status: z.string(),
  description: z.string().nullable(),
});

export const UserSchema = z.object({
  id: z.string().uuid(),
  uuid: z.string(),
  isActivePlan: z.boolean(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  gender: z.string().nullable(),
  role: z.string(),
  rank: z.string(),
  username: z.string().nullable(),
  email: z.string().nullable(),
  avatar: z.string(),
  activatedPlanAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
  deletedAt: z.string().nullable(),
});

export const LoanTransactionSchema = BaseLoanTransactionSchema.extend({
  transaction: TransactionSchema.nullable(),
});

export const UserLoanSchema = z.object({
  id: z.string().uuid(),
  uid: z.number(),
  startDate: z.string().datetime(),
  endDate: z.string().datetime(),
  paidInstallments: z.number(),
  status: z.string(),

  liquidityValue: z.string(),
  marginCallValue: z.string(),
  freeMarginValue: z.string(),

  amount: z.string(),
  targetLtv: z.string(),
  currentLtv: z.string(),
  remainingAmount: z.string(),

  reliability: z.string(),
  transferPaymentFineType:
    TransferPaymentFineEnum.transferPaymentFineTypeSchema,
  receivedCurrency: z.string(),

  initialCollateralPrice: z.string(),
  unpaidInstallments: z.number(),
  collateralAmount: z.string(),

  transferredAmount: z.string().nullable(),
  purpose: z.string().optional(),
  penalty: z.any().nullable(),

  monthlyRepay: z.string(),

  acceptedAt: z.string().nullable(),
  nextRepaymentDate: z.string().datetime(),
  lastInstallmentAt: z.string().nullable(),

  updatedAt: z.string().datetime(),
  createdAt: z.string().datetime(),

  loan: LoanSchema,
  user: UserSchema,
});

export const TransactionsSchema = z.tuple([
  z.array(LoanTransactionSchema),
  z.number(),
]);

export const LoansUserSlugDataSchema = z.object({
  transactions: TransactionsSchema,
  userLoan: UserLoanSchema,
});

const LoansUserSlugResponse = z.object({
  data: LoansUserSlugDataSchema,
  meta: MetaSchema.default,
});

export type LoansUserSlugResponseType = z.infer<typeof LoansUserSlugResponse>;
export type LoanTransactionItemType = z.infer<typeof LoanTransactionSchema>;

export default LoansUserSlugResponse;
